// Shared helpers for service day-of-week availability flags.
//
// Column/field names mirror the backend (salon_services / staff_services):
// `sunday_allowed` .. `saturday_allowed`. An undefined flag is treated as
// available (default true) so legacy services stay bookable on every day.

import type { DayAllowedFlags, DayAllowedKey } from "../../../types/salon";

// The types live in src/types so non-component modules (e.g. the staff form
// types) can share them; re-exported here for existing importers.
export type { DayAllowedFlags, DayAllowedKey };

// Week order starts on Sunday to match the backend day ordering.
export const DAY_ALLOWED_OPTIONS: {
  key: DayAllowedKey;
  label: string;
  short: string;
}[] = [
  { key: "sunday_allowed", label: "Sunday", short: "Sun" },
  { key: "monday_allowed", label: "Monday", short: "Mon" },
  { key: "tuesday_allowed", label: "Tuesday", short: "Tue" },
  { key: "wednesday_allowed", label: "Wednesday", short: "Wed" },
  { key: "thursday_allowed", label: "Thursday", short: "Thu" },
  { key: "friday_allowed", label: "Friday", short: "Fri" },
  { key: "saturday_allowed", label: "Saturday", short: "Sat" },
];

export const DAY_ALLOWED_KEYS: DayAllowedKey[] = DAY_ALLOWED_OPTIONS.map(
  (option) => option.key,
);

/**
 * Reads the 7 day-of-week flags from a source object (a salon service, staff
 * service, or form-settings object), defaulting any missing flag to `true`.
 */
export function extractDayFlags(source: any): DayAllowedFlags {
  const flags = {} as DayAllowedFlags;
  for (const key of DAY_ALLOWED_KEYS) {
    flags[key] = source?.[key] ?? true;
  }
  return flags;
}
